import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/trash.vue
var s = {
	name: "DtIconTrash",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--trash"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Trash",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [i("g", {
		"clip-path": `url(#${e.uniqueID}a)`,
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		fill: "currentColor"
	}, [...t[0] || (t[0] = [i("path", { d: "M5 5a.5.5 0 0 1 .5.5v3a.5.5 0 1 1-1 0v-3A.5.5 0 0 1 5 5Zm2 0a.5.5 0 0 1 .5.5v3a.5.5 0 1 1-1 0v-3A.5.5 0 0 1 7 5Z" }, null, -1), i("path", { d: "M1.5 2.5a.5.5 0 0 0 0 1H2V10c0 .413.201.784.46 1.041.257.258.628.46 1.04.46h5c.413 0 .784-.202 1.041-.46.258-.258.46-.628.46-1.04V3.5h.5a.5.5 0 0 0 0-1h-2V2c0-.413-.202-.784-.46-1.042C7.784.701 7.413.5 7.001.5H5c-.413 0-.784.201-1.042.46-.258.257-.459.628-.459 1.04v.5h-2ZM3 10a.51.51 0 0 0 .166.334.51.51 0 0 0 .334.166h5a.51.51 0 0 0 .334-.166A.511.511 0 0 0 9 10V3.5H3V10Zm1.5-8a.51.51 0 0 1 .166-.334A.51.51 0 0 1 5 1.5h2a.51.51 0 0 1 .334.166A.51.51 0 0 1 7.5 2v.5h-3V2Z" }, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=trash.js.map